import { useMemo } from 'react';
import { PERMISSIONS } from '@ithelpdesk/shared';
import { useDesignWorkflowMe } from '../api/design-workflow';
import { usePermission } from '../api/session';
import type { NavFlags } from './nav';

/**
 * Server-derived facts that reveal extra sidebar / command-palette entries.
 *
 * The Design Workflow entry is shown to anyone with baseline access who
 * actually takes part (`GET /design-requests/me` -> `isParticipant`). The
 * query only runs for an actor who holds that baseline permission, so nobody
 * else pays for (or is told anything by) the call. UX only: every
 * `/design-requests` endpoint re-checks on the server.
 */
export function useNavFlags(): NavFlags {
  const hasDesignAccess = usePermission(PERMISSIONS.DESIGN_WORKFLOW_ACCESS);
  const me = useDesignWorkflowMe({ enabled: hasDesignAccess });
  const participant = hasDesignAccess && me.data?.isParticipant === true;
  return useMemo(() => ({ designWorkflowParticipant: participant }), [participant]);
}
